/* istanbul ignore file */
/* eslint-disable */
// @ts-nocheck

/**
 * Clamp a value between a min and max value
 * @ignore
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @return {number}
 */
// eslint-disable-next-line import/no-default-export
export default function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
